<template>
  <!-- <div class="dialog" :style="{ display: istrue ? 'block' : 'none' }"> -->
  <div class="Win">
    <div class="Winmain">
      <div class="header">
        <b>{{ $t(title) }}</b
        ><i @click="close" class="iconfont icon-guanbi-1"></i>
      </div>
      <div v-if="ind === 0" class="title">
        <!--连续签到7天的用户中奖名单-->
        <p>{{ $t("300171") }}</p>
        <div v-if="userList.length > 0">
          <!--账号   奖励-->
          <p>
            <span>{{ $t("300085") }}</span
            ><span>{{ $t("300131") }}</span>
          </p>
          <div class="winuser">
            <div>
              <p v-for="(item, index) in userList" :key="index">
                <span>{{ item.account }}</span
                ><span>500&nbsp;ET</span>
              </p>
            </div>
          </div>
        </div>
        <van-empty class="custom-image" :description="$t('300108')" v-else>
          <svg slot="image" class="icon" aria-hidden="true">
            <use xlink:href="#icon-zanwujilu"></use>
          </svg>
        </van-empty>
      </div>
      <div class="content" v-else v-html="content"></div>
      <div class="Btn">
        <span @click="close">{{ $t("300141") }}</span>
      </div>
    </div>
  </div>
  <!-- </div> -->
</template>

<script>
import { userwind } from "../api/resource";
import Methods from "../utils/methods";
import { Empty } from "vant";
export default {
  props: {
    istrue: {
      type: Boolean,
      default: false
    },
    closedialog: {
      type: Function,
      default: () => {}
    },
    title: {
      type: String,
      default: ""
    },
    content: {
      type: String,
      default: ""
    },
    ind: {
      type: Number,
      default: 0
    }
  },
  components: {
    vanEmpty: Empty
  },
  data() {
    return {
      userList: []
    };
  },
  created() {
    userwind().then(res => {
      this.userList = res.data;
    });
  },
  methods: {
    close() {
      this.closedialog(false);
    }
  }
};
</script>

<style lang="scss" scoped>
@import "../assets/css/variableName";
@import "../style/mixin";

.Win {
  width: 100%;
  height: 100%;
  > div {
    width: torem(312);
    height: auto;
    background: #2a2d35;
    padding: torem(24) torem(20);
  }
}
.header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: torem(10);
  b {
    font-size: torem(16);
    color: #fff;
  }
  i {
    font-size: torem(14);
    color: rgba(255, 255, 255, 0.6);
    font-weight: 100;
  }
}
.title {
  text-align: center;
  font-size: torem(14);
  color: rgba(255, 255, 255, 0.6);
  width: torem(272);
  //height: torem(198) !important;
  padding-top: torem(24);
  > div {
    padding-top: torem(30);
    p {
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: torem(14);
      color: rgba(255, 255, 255, 0.6);
    }
  }
}
.dialog {
  width: 100%;
  height: 100%;
  background: rgba($color: #000000, $alpha: 0.3);
  position: fixed;
  top: 0;
  left: 0;
  z-index: 999;
}
.Btn {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: torem(24);
  span {
    display: inline-block;
    width: torem(272);
    height: torem(44);
    background: #ffc72b;
    text-align: center;
    line-height: torem(44);
    color: #333;
    border-radius: torem(4);
    font-size: torem(14);
  }
}
.Winmain {
  display: flex;
  flex-direction: column;
  border-radius: torem(16);
}
.content {
  padding: torem(10);
  font-size: torem(14);
  line-height: 1.5;
  max-height: torem(273);
  overflow-y: auto;
}
.winuser {
  line-height: torem(30);
  padding-top: torem(10);
  max-height: torem(126);
  overflow-y: auto;
  p {
    span {
      color: #fff;
    }
  }
}
.custom-image {
  padding-top: torem(60) !important;
  /deep/ .van-empty__image {
    width: torem(56);
    height: torem(56);
    svg {
      width: torem(56);
      height: torem(56);
    }
  }
  /deep/ .van-empty__description {
    font-size: torem(14);
  }
}
</style>



// WEBPACK FOOTER //
// src/compontents/dialog.vue